module.exports = __webpack_public_path__ + "img/loading-screen.7fb624be.gif";